export default __webpack_public_path__ + "static/media/17t.ac056837.jpg";